import { render, staticRenderFns } from "./WorkflowBadge.vue?vue&type=template&id=63176dc5&scoped=true"
import script from "./WorkflowBadge.vue?vue&type=script&lang=js"
export * from "./WorkflowBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63176dc5",
  null
  
)

export default component.exports